/* =====================================================================
   XEIST Locker Room — coach enhancements (v5)
   Supersedes v4.js. Fixes two issues found on the live Purchased tab:
     • Empty state never showed — the listing window is NOT inside
       .kb-locker-room-tabular-wrapper; KB renders the empty area as
       .kb-window-titled-contents.kb-folder-empty* under .kb-locker-room-
       folder. listContainer() now targets that.
     • Logout still rendered as KB's dark pill — KB styles it from a
       cross-origin stylesheet with !important + high specificity that no
       theme rule can out-specify. Restyle it with inline !important
       (the only thing that wins) via styleLogout().
   Plus the v4 launcher + per-card action row. Locker route only.
   ===================================================================== */
(function () {
  if (window.location.pathname.indexOf('/pages/3d-customizer') === -1) return;

  var ACCENT = '#5b3fd6', INK = '#171a20', MUTED = '#6b6b76', LINE = '#ececf1';
  var FONT = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
  var CREATE_HASH = '/customise/114891065';

  function onLocker() {
    return (window.location.hash || '').indexOf('/locker-room') !== -1;
  }

  function findScope(el) {
    if (!window.angular) return null;
    var s, d = 0;
    try { s = angular.element(el).scope(); } catch (e) { return null; }
    while (s && d < 8) {
      if (s.item && s.vm && typeof s.vm.buyCustomDesign === 'function') return s;
      s = s.$parent; d++;
    }
    return null;
  }

  function fireAction(li, sc, kbSelector, vmMethod) {
    var btn = li.querySelector(kbSelector);
    if (btn) { btn.click(); return true; }
    if (sc && sc.vm && typeof sc.vm[vmMethod] === 'function') {
      try { sc.$apply(function () { sc.vm[vmMethod](sc.item); }); return true; }
      catch (e) { try { sc.vm[vmMethod](sc.item); return true; } catch (e2) {} }
    }
    return false;
  }

  function makeBtn(cls, label, handler) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.textContent = label;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      handler();
    });
    return b;
  }

  function enhanceCard(li) {
    if (li.querySelector('.xeist-card-actions')) return;
    var sc = findScope(li);
    if (!sc) return;
    if (sc.item && sc.item.purchasable === false) return;

    var wrap = document.createElement('div');
    wrap.className = 'xeist-card-actions';

    wrap.appendChild(makeBtn('xeist-reorder-btn', 'Reorder', function () {
      fireAction(li, sc, '[class*="kb-buy-custom-design"]', 'buyCustomDesign');
    }));

    var row = document.createElement('div');
    row.className = 'xeist-card-actions__row';
    row.appendChild(makeBtn('xeist-card-link', 'Edit', function () {
      fireAction(li, sc, '[class*="kb-edit-custom-design"]', 'editCustomDesign');
    }));
    row.appendChild(makeBtn('xeist-card-link', 'Copy', function () {
      fireAction(li, sc, '[class*="kb-copy-custom-design"]', 'showCopyCustomDesignDialog');
    }));
    row.appendChild(makeBtn('xeist-card-link', 'Share', function () {
      fireAction(li, sc, '[class*="kb-share-custom-design"]', 'showBasicShareDialog');
    }));
    wrap.appendChild(row);

    li.appendChild(wrap);
  }

  /* ---- Logout: inline !important is the only thing that beats KB's
     cross-origin styling ---- */
  function styleLogout() {
    var lo = document.querySelector('.kb-locker-room-logout-button');
    if (!lo || lo.getAttribute('data-xeist-logout') === '1') return;
    lo.style.setProperty('background-color', 'transparent', 'important');
    lo.style.setProperty('background-image', 'none', 'important');
    lo.style.setProperty('color', MUTED, 'important');
    lo.style.setProperty('border', '1px solid ' + LINE, 'important');
    lo.style.setProperty('border-radius', '999px', 'important');
    lo.style.setProperty('box-shadow', 'none', 'important');
    lo.style.setProperty('text-transform', 'none', 'important');
    lo.style.setProperty('font-weight', '600', 'important');
    lo.style.setProperty('padding', '8px 16px', 'important');
    lo.setAttribute('data-xeist-logout', '1');
  }

  function svgIcon(paths) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + paths + '</svg>';
  }
  function launcherCard(icon, title, sub) {
    return '<button class="xl-card" type="button"><span class="xl-ic">' + icon + '</span>' +
      '<span class="xl-txt"><span class="xl-t">' + title + '</span><span class="xl-s">' + sub + '</span></span></button>';
  }
  function injectLauncher() {
    if (document.getElementById('xeist-launcher')) return;
    var host = document.querySelector('.kb-locker-room-tabular-wrapper') ||
               document.querySelector('.kb-locker-room-wrapper');
    if (!host || !host.parentNode) return;

    var cart = svgIcon('<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/>');
    var pen = svgIcon('<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>');
    var folder = svgIcon('<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>');

    var div = document.createElement('div');
    div.id = 'xeist-launcher';
    div.innerHTML =
      launcherCard(cart, 'Reorder Gear', 'Get more of what your team already has') +
      launcherCard(pen, 'Create New Design', 'Start fresh for the season') +
      launcherCard(folder, 'View Saved Designs', 'See &amp; manage your team gear');

    if (!document.getElementById('xeist-launcher-head')) {
      var head = document.createElement('div');
      head.id = 'xeist-launcher-head';
      head.textContent = 'What would you like to do today?';
      host.parentNode.insertBefore(head, host);
    }
    host.parentNode.insertBefore(div, host);

    var btns = div.querySelectorAll('.xl-card');
    btns[0].addEventListener('click', function () {
      var t = document.querySelector('.kb-locker-room-tab-purchased');
      if (t) t.click();
    });
    btns[1].addEventListener('click', function () {
      window.location.hash = CREATE_HASH;
    });
    btns[2].addEventListener('click', function () {
      var t = document.querySelector('.kb-locker-room-tab-saved');
      if (t) t.click();
    });
  }

  /* ---- Empty states ------------------------------------------------- */
  function activeTabKey() {
    var t = document.querySelector('.kb-locker-room-tab-active');
    var c = t ? String(t.className) : '';
    if (/purchased/.test(c)) return 'purchased';
    if (/basket/.test(c)) return 'basket';
    return 'saved';
  }
  function emptyCopy(key) {
    if (key === 'purchased') return { t: 'No orders yet', s: 'Gear your team orders will show up here so you can reorder it in one tap.', cta: 'Browse saved designs', act: 'saved' };
    if (key === 'basket') return { t: 'Your basket is empty', s: 'Add a saved design to your basket when you’re ready to order.', cta: 'View saved designs', act: 'saved' };
    return { t: 'No saved designs yet', s: 'Create your first team design and it’ll live here for easy reordering all season.', cta: 'Create New Design', act: 'create' };
  }
  /* KB renders the empty listing as .kb-window-titled-contents.kb-folder-empty*
     under .kb-locker-room-folder — NOT under .kb-locker-room-tabular-wrapper. */
  function listContainer() {
    return document.querySelector('.kb-window-titled-contents[class*="kb-folder-empty"]') ||
           document.querySelector('.kb-locker-room-folder .kb-window-titled-contents') ||
           document.querySelector('.kb-locker-room-wrapper .kb-window-titled-contents:not(.kb-locker-room-bottom-content)');
  }
  function hasItems() {
    return document.querySelectorAll('li.kb-custom-design-icon, li.kb-folder-icon').length > 0;
  }

  var emptyTimer = null;
  function manageEmptyState() {
    var c = listContainer();
    if (!c) return;
    var existing = c.querySelector('.xeist-empty');
    if (hasItems()) {
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      if (emptyTimer) { clearTimeout(emptyTimer); emptyTimer = null; }
      return;
    }
    if (existing || emptyTimer) return;
    /* Wait out KB's async render before declaring "empty" (avoids a flash
       while the list is still loading). Re-verify at fire time. */
    emptyTimer = setTimeout(function () {
      emptyTimer = null;
      if (!onLocker() || hasItems()) return;
      var cc = listContainer();
      if (!cc || cc.querySelector('.xeist-empty')) return;
      var copy = emptyCopy(activeTabKey());

      var box = document.createElement('div');
      box.className = 'xeist-empty';
      box.style.cssText = 'display:flex;flex-direction:column;align-items:center;text-align:center;' +
        'gap:6px;padding:48px 24px 40px;font-family:' + FONT + ';';

      var ic = document.createElement('div');
      ic.style.cssText = 'width:64px;height:64px;border-radius:50%;background:#f1edff;display:flex;' +
        'align-items:center;justify-content:center;margin-bottom:8px;';
      ic.innerHTML = '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="' + ACCENT +
        '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>';
      box.appendChild(ic);

      var t = document.createElement('div');
      t.textContent = copy.t;
      t.style.cssText = 'font-weight:800;font-size:18px;color:' + INK + ';';
      box.appendChild(t);

      var s = document.createElement('div');
      s.textContent = copy.s;
      s.style.cssText = 'font-size:14px;color:' + MUTED + ';max-width:340px;line-height:1.4;';
      box.appendChild(s);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = copy.cta;
      btn.style.cssText = 'margin-top:14px;border:none;border-radius:999px;background:' + ACCENT + ';' +
        'color:#fff;font-family:' + FONT + ';font-weight:700;font-size:14px;padding:12px 24px;' +
        'cursor:pointer;box-shadow:0 8px 20px rgba(91,63,214,0.25);';
      btn.addEventListener('click', function () {
        if (copy.act === 'create') { window.location.hash = CREATE_HASH; }
        else { var st = document.querySelector('.kb-locker-room-tab-saved'); if (st) st.click(); }
      });
      box.appendChild(btn);

      cc.appendChild(box);
    }, 900);
  }

  function enhance() {
    if (!onLocker()) return;
    injectLauncher();
    styleLogout();
    var cards = document.querySelectorAll('li.kb-custom-design-icon');
    for (var i = 0; i < cards.length; i++) enhanceCard(cards[i]);
    manageEmptyState();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; enhance(); });
  }

  function start() {
    enhance();
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* noop */ }
    window.addEventListener('hashchange', function () { setTimeout(enhance, 300); });
    /* Safety net in case the observer misses KB's async render */
    var n = 0;
    var iv = setInterval(function () { n++; enhance(); if (n > 20) clearInterval(iv); }, 700);
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
